<template>
<div class="chapter">
<div class="inner_page">
<h1 class="part"><a id="page1"></a><img alt="" src="OEBPS/images/tp.png"/><br/><a href="#/OEBPS/toc.htm#p1-tp">FINAL<br/>EDITION</a><br/><img alt="" src="OEBPS/images/tp.png"/></h1>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// p1-tp.vue?37ec9f22